import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import _ from "lodash";
import Articlegroup from "../../models/menu/Articlegroup.ts";

export const selectArticlegroupsMap = createSelector(
  [(state: RootState) => state.menuData.menukaarts],
  (articlegroups): PartialRecord<string, Articlegroup> => _.keyBy(articlegroups, "id")
);
